import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  roomType: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainRoomType: [],
};

// TODO: fetch all the roomType
export const fetchRoomType = createAsyncThunk(
  "fetchRoomType/roomType",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`hotel-room-type`, {
        params: {
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create roomType
export const createRoomType = createAsyncThunk(
  "createRoomType/roomType",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`hotel-room-type`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update roomType
export const updateRoomType = createAsyncThunk(
  "updateRoomType/roomType",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`hotel-room-type/${id}`, data);
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete roomType
export const deleteRoomType = createAsyncThunk(
  "deleteRoomType/roomType",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`hotel-room-type/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const roomTypelice = createSlice({
  name: "roomType",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get roomType
    builder.addCase(fetchRoomType.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRoomType.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.roomType.data = action.payload.data;
      state.roomType.meta.total = action.payload.meta.total;
    });

    builder.addCase(fetchRoomType.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create roomType
    builder.addCase(createRoomType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRoomType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roomType.data = [action.payload.data, ...state.roomType.data];
      state.roomType.meta.total = state.roomType.meta.total + 1;
      action.payload.enqueueSnackbar("RoomType is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createRoomType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update roomType
    builder.addCase(updateRoomType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRoomType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roomType.data = state?.roomType?.data?.map((roomType) => {
        if (roomType.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return roomType;
        }
      });
      action.payload.enqueueSnackbar("RoomType is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateRoomType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete roomType
    builder.addCase(deleteRoomType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRoomType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roomType.data = state.roomType.data.filter(
        (roomType) => roomType.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("RoomType is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteRoomType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default roomTypelice.reducer;

export const { resetLoadings } = roomTypelice.actions;
